import { cva } from 'class-variance-authority'

export const avatarVariants = cva(
  'relative flex shrink-0 items-center justify-center overflow-hidden rounded-full',
  {
    variants: {
      size: {
        'extra-small': 'size-4',
        small: 'size-6',
        medium: 'size-8',
        large: 'size-12',
      },
      color: {
        default: 'bg-palette-gray-100',
        amber: 'bg-palette-amber-100',
        emerald: 'bg-palette-emerald-100',
        teal: 'bg-palette-teal-100',
        cyan: 'bg-palette-cyan-100',
        sky: 'bg-palette-sky-100',
        indigo: 'bg-palette-indigo-100',
        violet: 'bg-palette-violet-100',
        purple: 'bg-palette-purple-100',
        fuchsia: 'bg-palette-fuchsia-100',
        pink: 'bg-palette-pink-100',
        rose: 'bg-palette-rose-100',
        lime: 'bg-palette-lime-100',
        blue: 'bg-palette-blue-100',
        orange: 'bg-palette-orange-100',
        gray: 'bg-palette-gray-100',
      },
    },
    defaultVariants: {
      size: 'small',
      color: 'default',
    },
  },
)

export const avatarFallbackVariants = cva(
  'flex size-full items-center justify-center rounded-full',
  {
    variants: {
      size: {
        'extra-small': '!text-2xs font-medium',
        small: '!text-body-small font-semibold',
        medium: '!text-label-default',
        large: '!text-heading-medium',
      },
    },
    defaultVariants: {
      size: 'small',
    },
  },
)

export const avatarListVariants = cva('flex items-center', {
  variants: {
    size: {
      'extra-small': 'gap-1',
      small: 'gap-1',
      medium: 'gap-1.5',
      large: 'gap-1.5',
    },
  },
  defaultVariants: {
    size: 'small',
  },
})

export const avatarOverlapVariants = cva('last:mr-0', {
  variants: {
    size: {
      'extra-small': '-mr-1.5',
      small: '-mr-1.5',
      medium: '-mr-2',
      large: '-mr-3',
    },
  },
  defaultVariants: {
    size: 'small',
  },
})

export const avatarOverflowBadgeVariants = cva('text-main-foreground-primary', {
  variants: {
    size: {
      'extra-small': '!text-2xs font-medium',
      small: '!text-body-small font-semibold',
      medium: '!text-label-default',
      large: '!text-heading-medium',
    },
  },
  defaultVariants: {
    size: 'small',
  },
})

export const avatarRingVariants = cva('ring-main-border-screen', {
  variants: {
    size: {
      'extra-small': 'ring-1',
      small: 'ring-2',
      medium: 'ring-2',
      large: 'ring-2',
    },
  },
  defaultVariants: {
    size: 'small',
  },
})

export const avatarChipVariants = cva(
  'flex w-fit items-center gap-1 rounded-full bg-main-background-interactive-secondary-default px-2 py-1 text-body-default',
  {
    variants: {
      clickable: {
        true: 'cursor-pointer',
        false: '',
      },
    },
    defaultVariants: {
      clickable: false,
    },
  },
)
